import { createFileRoute, Outlet } from '@tanstack/react-router'
import { UsersLogWidget } from '@/widgets/users-log-widget'

export const Route = createFileRoute('/_auth/journal/tabs/users')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <UsersLogWidget />
      <Outlet />
    </>
  )
}
